export interface DroneProfile {
  id: string;
  name: string;
  eid: string;
  drone_model: string;
  drone_model_name?: string;
  createdAt: Date;
  updatedAt: Date;
  device_uuid: string;
}

export type DroneProfilePatch = { id: string } & Partial<Omit<DroneProfile, 'id'>>;
export type DroneProfileCreate = Omit<DroneProfile, 'id' | 'createdAt' | 'updatedAt'>;

export interface DroneProfileBackend {
  id: string;
  name: string;
  eid: string;
  drone_model: string;
  drone_model_name: string;
  created_at: string;
  updated_at: string;
  device_uuid: string;
}

export interface FullDroneProfileInput {
  name: string;
  eid: string;
  drone_model: string;
  organization: number;
  device_uuid: string;
}

export enum DroneState {
  BOOTING = 'booting',
  IDLE = 'idle',
  PERFORMING_FACTORY_RESET = 'performing-factory-reset',
  AWAITING_PROVISIONING = 'awaiting-provisioning',
  UPDATING = 'updating',
  ON_MISSION = 'on-mission',
  HARDWARE_ERROR = 'hardware-error',
  NETWORK_ERROR = 'network-error',
  CONFIGURATION_ERROR = 'configuration-error',
  LOW_BATTERY = 'low-battery',
  SHUTDOWN = 'shutdown',
}

export enum ProvisioningState {
  UNPROVISIONED = 'unprovisioned',
  PROVISIONING = 'provisioning',
  PROVISIONED = 'provisioned',
}

export interface DroneData {
  data: {
    eid: string;
    name: string;
    state: DroneState;
    battery: {
      percentage: number;
      type: string;
    };
    provisioning_state: ProvisioningState;
    location: {
      lat: string;
      lon: string;
    };
  };
}

export type OrganizationDroneProfiles = {
  data: {
    drone_profiles: DroneProfile[];
  };
};

export interface DroneHeartBeat {
  id: number;
  timestamp: string;
  device_uuid: string;
  device_uuid_source?: string;
  ip_eth0?: string[];
  ip_wlan0?: string[];
  ip_docker0?: string[];
  ip_br_ce35e312a760?: string[];
  ip_veth5c573f7?: string[];
  cpu_temperature?: number;
  interrupts?: number;
  uptime_seconds?: number;
  battery_percentage?: number;
  cpu_load?: Record<string, number>;
  memory?: Record<string, number>;
  disk_io?: Record<string, number>;
  network_usage?: Record<string, number>;
  packet_statistics?: Record<string, any>;
  nodes_metrics?: Record<string, any>;
  raw_json?: any;
  created_at: string;
  drone: number;
}
